import { useEffect } from "react";
import { Button } from "../../../../components/buttons/button";
import { PopoverMenu } from "../../../../components/dropdown/popover";
import { CaretDown } from "../../../../components/icon/downcaret";
import { FindEventsFilterModal } from "../../../../components/modal/app_modals/findEventsFilterModal";
import { useModalControl } from "../../../../customeHooks/useModalControl";
import { useWindowDimensions } from "../../../../customeHooks/useWindowDimensions";
import {
  AvailableCountries,
  FindEventsQuery,
} from "../../../../redux/features/event/event.types";
import { useAppSelector } from "../../../../redux/hooks";

export const LocationFilter = ({
  query,
  setQuery,
}: {
  query: FindEventsQuery;
  setQuery: (q: FindEventsQuery) => void;
}) => {
  const { handleModalClose, handleModalOpen, modal, modalOpen } =
    useModalControl();

  const { deviceAddressDetails } = useAppSelector((state) => state.auth);

  const { width } = useWindowDimensions();

  const locationFilters: {
    name: string;
    value: AvailableCountries;
    onClick: () => void;
  }[] = [
    {
      name: `Nigeria`,
      value: "Nigeria",
      onClick: () => {
        setQuery({
          ...query,
          category: undefined,
          page: 1,
          country: "Nigeria",
          price: undefined,
        });
      },
    },
    {
      name: `Canada`,
      value: "Canada",
      onClick: () => {
        setQuery({
          ...query,
          category: undefined,
          page: 1,
          country: "Canada",
          price: undefined,
        });
      },
    },
  ];

  useEffect(() => {
    if (deviceAddressDetails?.country) {
      setQuery({
        ...query,
        category: undefined,
        page: 1,
        country:
          deviceAddressDetails.country === "Nigeria" ? "Nigeria" : "Canada",
      });
    }
    // eslint-disable-next-line
  }, [deviceAddressDetails]);

  return (
    <>
      <PopoverMenu
        menuItems={locationFilters}
        menuClassName="!min-w-[177px] !rounded-xl !hidden md:!flex"
        menuItemsClassName="!text-grey-950 !font-bold"
        position="bottom start"
        closeOnClick
        className="min-w-max"
      >
        {({ open }) => (
          <Button
            type="button"
            text={
              !!query.country
                ? locationFilters.find((item) => item.value === query.country)
                    ?.name!
                : `Location`
            }
            icon="map-pin"
            iconDimension={20}
            variation="plain-text-grey"
            className={``}
            extra={<CaretDown width={20} height={20} />}
            onClick={
              width < 768
                ? () => {
                    handleModalOpen("locationFilterModal");
                  }
                : undefined
            }
          />
        )}
      </PopoverMenu>

      <FindEventsFilterModal
        open={modalOpen && modal === "locationFilterModal"}
        handleClose={() => {
          handleModalClose();
        }}
        title="Filter by location"
      >
        <div className="flex flex-col">
          {locationFilters.map((item, idx) => {
            return (
              <button
                type="button"
                className="w-full border-b border-b-grey-100 py-4 text-left text-sm font-bold last:border-b-0"
                onClick={() => {
                  item.onClick();
                  handleModalClose();
                }}
                key={`filter-${idx}-${item.value}`}
              >
                {item.name}
              </button>
            );
          })}
        </div>
      </FindEventsFilterModal>
    </>
  );
};
